import React from "react";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import ApplicationsTable from "../components/Ag-Grid";
import ApplicationEditor from "../components/student/ApplicationEditor";
import ApplicationView from "../components/student/ApplicationView";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { isAuthenticated } from "../util";

function ShowApplicationViewer(props) {
  return (
    <div>
      <Header />
      <ApplicationView {...props} />
      <Footer />
    </div>
  );
}

function ShowApplicationEditor(props) {
  return (
    <div>
      <Header />
      <ApplicationEditor {...props} />
      <Footer />
    </div>
  );
}

function ShowApplicationsTable(props) {
  return (
    <div>
      <Header />
      <ApplicationsTable {...props} />
      <Footer />
    </div>
  );
}

function Application(props) {
  const applications = useSelector((state) => state.applications.records);
  const token = useSelector((state) => state.auth.token);
  const expiresAt = useSelector((state) => state.auth.expiresAt);

  if (!isAuthenticated(token, expiresAt)) {
    return <Redirect to="/" />;
  }

  // TODO the logic below is poor and it needs to be refactored!

  const query = new URLSearchParams(props.location.search);
  const applicationId = query.get("id");
  // if the url includes application id (instead of year and term), then
  // a student is fetching a specific application!
  if (applicationId) {
    const application = applications.find((app) => app._id === applicationId);
    if (application) {
      return <ShowApplicationViewer application={application} />;
    }
  }

  const year = query.get("year");
  const term = query.get("term");
  const jhed = query.get("jhed");
  if (year && term) {
    // if the url includes "jhed" in addition to year and term,
    // then a student is trying to submit a new application!
    return jhed ? (
      <ShowApplicationEditor year={year} term={term} />
    ) : (
      <ShowApplicationsTable year={year} term={term} />
    );
  }

  return <Redirect to="/dashboard" />;
}

export default Application;
